import { SearchBarTableConfig } from 'AppConfig/TableConfig/SearchBar';

// "SearchBar.ResultsProcessStatementTable.IndicatorId"
const parseExpression = (input) => {
  const PREFIX = 'SearchBar.';

  if (!input.startsWith(PREFIX)) {
    return undefined;
  }

  const path = input.slice(PREFIX.length).split('.');
  if(!(path || []).length) {
    return undefined;
  }

  return path.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : null, SearchBarTableConfig);
}

export const getCustomSearchBar = (path) => {
  const filterFunction = parseExpression(path);

  if(!filterFunction) {
    return undefined;
  }

  return filterFunction;
}
